export const toggleMetricsMode = mode => ({
  type: "TOGGLE_METRICS_MODE",
  mode
});
